import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';

const MinusIconShadow = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 71}
          height={props.height ?? 58}
          viewBox="0 0 71 58"
          fill="none"
          {...props}
        >
          <Path
            d="M48.0322 45.324C49.568 44.4499 50.8125 42.2781 50.8125 40.5035L50.8125 17.7782C50.8125 16.0036 49.568 13.8582 48.0322 12.9576L28.3584 1.59499C26.8226 0.72094 24.3336 0.720939 22.7979 1.59499L3.12403 12.9576C1.58826 13.8317 0.343749 16.0036 0.343749 17.7782L0.343748 40.5035C0.343748 42.2781 1.58825 44.4235 3.12403 45.324L22.7978 56.6866C24.3336 57.5607 26.8226 57.5607 28.3584 56.6866L48.0322 45.324Z"
            fill="#FFB600"
            fillOpacity="0.22"
          />
          <Path
            d="M20.0781 22.7363H70.9656V38.0026H20.0781V22.7363Z"
            fill="url(#paint0_linear_1_39126)"
          />
          <Defs>
            <LinearGradient
              id="paint0_linear_1_39126"
              x1="45.5219"
              y1="22.7363"
              x2="45.5219"
              y2="38.0026"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor="#FFCF53" />
              <Stop offset="1" stopColor={'#FF9900'} />
            </LinearGradient>
          </Defs>
        </Svg>
      </View>
    );
  },
);

export { MinusIconShadow };
